
import {Component, Vue} from 'vue-property-decorator';
import {
  readHasModuleAccess,
  readUserProfile,
} from '@/store/main/getters';

import {dispatchGetUserProfile} from '@/store/main/actions';
import AdminInfos from '@/components/stats-dashboard/AdminInfos.vue';
import AllRegisteredForms from '@/components/stats-dashboard/AllRegisteredForms.vue';
import LastVisitedPages from '@/components/stats-dashboard/LastVisitedPages.vue';

@Component({
  components: {LastVisitedPages, AllRegisteredForms, AdminInfos},
})
export default class Dashboard extends Vue {
  private get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      if (userProfile.fullname) {
        return userProfile.fullname;
      } else {
        return userProfile.email;
      }
    }
  }

  public hasModuleAccess(val) {
    return readHasModuleAccess(this.$store)(val);
  }

  public async mounted() {
    if (!readUserProfile(this.$store))
      await dispatchGetUserProfile(this.$store);
  }
}
